<template>
    <div class="blank-container">
        <div class="banner">{{ src }}
            <img :src="src?src:'/static/img/common/default-banner.png'">
        </div>
        <div class="cmpt-detail">
            <div class="cmpt-type-yq" v-if="dcCmptsetting.cmptType === 1">
                <span>{{ $t('dc_lang.邀请赛') }}</span>
            </div>
            <div class="cmpt-type" :style="{'left': dcCmptsetting.cmptType === 1 ? '' : 0}">
                <span>{{ cmptAttr }}</span>
            </div>
            <div class="cmpt-title"><span>{{ name }}</span></div>
            <div class="cmpt-award" v-if="cmptId != '320'"><span class="total-award">{{ $t('dc_lang.奖金池') }}:&nbsp;<span
                class="cmpt-money">{{ award }}</span></span></div>
            <div class="cmpt-host"><span>{{ $t('dc_lang.主办方') }}:&nbsp;{{ host }}</span></div>
            <template v-if="statusState==='joinable'">
                <div class="cmpt-progress" style="display:block">
                    <div class="progress-left">
                        <img src="../../../../static/img/competition-details/cmp-progress@2x.png">
                        <span>{{ $t('dc_lang.当前阶段') }}:&nbsp;<span style="color:#BDC1C7">{{ status }}</span></span>
                    </div>
                </div>
            </template>
            <template v-else-if="statusState==='history'">
                <div class="cmpt-progress">
                    <div class="progress-left" style="position: relative">
                        <img src="../../../../static/img/competition-details/cmp-progress@2x.png">
                        <span>{{ $t('dc_lang.当前阶段') }}:&nbsp;<span
                            class="status">{{ $t('dc_lang.竞赛已结束') }}</span></span>
                        <div class="finish-toast" v-if="tipShow">{{ $t('dc_lang.你可以报名参赛，并提交得到排名，但不会获得实物奖励。') }}</div>
                    </div>
                </div>
            </template>
            <!--进行中-->
            <template v-else>
                <div class="cmpt-progress">
                    <div class="progress-left">
                        <img src="../../../../static/img/competition-details/cmp-progress@2x.png">
                        <span>{{ $t('dc_lang.当前阶段') }}:&nbsp;<span style="color:#46D684">{{ status }}</span></span>
                    </div>
                    <!--阶段进行中-->
                    <div class="progress-right">
                        <img src="../../../../static/img/competition-details/cmp-count@2x.png">
                        <span>报名倒计时:&nbsp;<span class="count-down"><span
                            v-if="days!==0">{{ days }}天</span>{{ hours }}:{{ minutes }}:{{ seconds }}</span></span>
                    </div>
                </div>
            </template>
            <div class="cmpt-data">
                <div class="cmpt-team">
                    <span>{{ $t('dc_lang.参赛队伍') }}:&nbsp;{{ cmpTeamNum }}</span>
                </div>
                <div class="cmpt-number">
                    <span>{{ $t('dc_lang.参赛人数') }}:&nbsp;{{ cmpMemberNum }}</span>
                </div>
                <div class="cmpt-work">
                    <span>{{ $t('dc_lang.作品提交数') }}:&nbsp;{{ cmpWorkNum }}</span>
                </div>
            </div>
        </div>
        <div class="scroll-view" :class="{barFixed:barFixed}" ref="scrollViewBox">
            <div class="scroll-view-inner" ref="scrollView" v-if="cmptId == 304">
                <div class="tab-wrapper" v-if="isJoin" ref="tabWrapper">
                    <router-link v-if="item.name=='竞赛信息'||item.name=='参赛人员'"
                                 :to="{path:item.url,query:{id:cmptId}}"
                                 :class="[tab,$route.path===item.url?'selected':'']" ref="tab"
                                 v-for="(item,index) in tabBarData304In" :key="index">
                        {{ item.name }}
                    </router-link>
                    <a :href="item.url" class="tab" v-else>{{ item.name }}</a>
                </div>
                <div class="tab-wrapper" v-else ref="tabWrapper">
                    <router-link v-if="item.name=='竞赛信息'||item.name=='参赛人员'"
                                 :to="{path:item.url,query:{id:cmptId}}"
                                 :class="[tab,$route.path===item.url?'selected':'']" ref="tab"
                                 v-for="(item,index) in tabBarData304Out" :key="index">
                        {{ item.name }}
                    </router-link>
                    <a href="javascript:;" class="tab" @click="signUpAlert304" v-else>{{ item.name }}</a>
                </div>
            </div>
            <div class="scroll-view-inner" ref="scrollView" v-else-if="cmptId == 320">
                <div class="tab-wrapper" v-if="isJoin" ref="tabWrapper">
                    <router-link :to="{path:item.url,query:{id:cmptId}}"
                                 :class="[tab,$route.path===item.url?'selected':'']" ref="tab"
                                 v-for="(item,index) in tabBarData320In" :key="index">
                        {{ item.name }}
                    </router-link>
                </div>
                <div class="tab-wrapper" v-else ref="tabWrapper">
                    <router-link :to="{path:item.url,query:{id:cmptId}}"
                                 :class="[tab,$route.path===item.url?'selected':'']" ref="tab"
                                 v-for="(item,index) in tabBarData320Out" :key="index">
                        {{ item.name }}
                    </router-link>
                </div>
            </div>
            <div class="scroll-view-inner" ref="scrollView" v-else-if="cmptId == 377">
                <div class="tab-wrapper" v-if="isJoin" ref="tabWrapper">
                    <router-link :to="{path:item.url,query:{id:cmptId}}"
                                 :class="[tab,$route.path===item.url?'selected':'']" ref="tab"
                                 v-for="(item,index) in tabBarData377In" :key="index">
                        {{ item.name }}
                    </router-link>
                </div>
                <div class="tab-wrapper" v-else ref="tabWrapper">
                    <router-link :to="{path:item.url,query:{id:cmptId}}"
                                 :class="[tab,$route.path===item.url?'selected':'']" ref="tab"
                                 v-for="(item,index) in tabBarData377Out" :key="index">
                        {{ item.name }}
                    </router-link>
                </div>
            </div>
            <div class="scroll-view-inner" ref="scrollView" v-else-if="cmptId == 331">
                <div class="tab-wrapper" v-if="isJoin" ref="tabWrapper">
                    <router-link :to="{path:item.url,query:{id:cmptId}}"
                                 :class="[tab,$route.path===item.url?'selected':'']" ref="tab"
                                 v-for="(item,index) in tabBarData331In" :key="index">
                        {{ item.name }}
                    </router-link>
                </div>
                <div class="tab-wrapper" v-else ref="tabWrapper">
                    <router-link :to="{path:item.url,query:{id:cmptId}}"
                                 :class="[tab,$route.path===item.url?'selected':'']" ref="tab"
                                 v-for="(item,index) in tabBarData331Out" :key="index">
                        {{ item.name }}
                    </router-link>
                </div>
            </div>
            <div class="scroll-view-inner" ref="scrollView" v-else-if="cmptId == 333 || cmptId == 334 || cmptId == 335">
                <div class="tab-wrapper" v-if="isJoin" ref="tabWrapper">
                    <router-link :to="{path:item.url,query:{id:cmptId}}"
                                 :class="[tab,$route.path===item.url?'selected':'']" ref="tab"
                                 v-for="(item,index) in tabBarData333In" :key="index">
                        {{ item.name }}
                    </router-link>
                </div>
                <div class="tab-wrapper" v-else ref="tabWrapper">
                    <router-link :to="{path:item.url,query:{id:cmptId}}"
                                 :class="[tab,$route.path===item.url?'selected':'']" ref="tab"
                                 v-for="(item,index) in tabBarData333Out" :key="index">
                        {{ item.name }}
                    </router-link>
                </div>
            </div>
            <div class="scroll-view-inner" ref="scrollView" v-else>
                <div class="tab-wrapper" v-if="isJoin" ref="tabWrapper">
                    <router-link :to="{path:item.url,query:{id:cmptId}}"
                                 :class="[tab,$route.path===item.url?'selected':'']" ref="tab"
                                 v-for="(item,index) in tabBarDataIn" :key="index">
                        {{ item.name }}
                    </router-link>
                </div>
                <div class="tab-wrapper" v-else ref="tabWrapper">
                    <router-link :to="{path:item.url,query:{id:cmptId}}" replace
                                 :class="[tab,$route.path===item.url?'selected':'']" ref="tab"
                                 v-for="(item,index) in tabBarDataOut" :key="index">
                        {{ item.name }}
                    </router-link>
                </div>
            </div>
        </div>
        <router-view v-if="isRouterShow"></router-view>
        <!--底部按钮-->
        <div class="button-wrapper" v-if="status !== '竞赛已结束'">
            <!--            <a v-if="isJoin" class="creative-download smallButton"-->
            <!--               href="https://challenge-os.videojj.com/?from=dc"><span>下载数据</span></a>-->
            <div class="signUp smallButton" @click="signUpAlert"><span>{{ $t('dc_lang.报名参赛') }}</span></div>
        </div>
        <!--        <template v-else>-->
        <!--            <template v-if="isJoin">-->
        <!--                &lt;!&ndash;比赛已结束&ndash;&gt;-->
        <!--                <template v-if="statusState==='history'">-->
        <!--                    <div class="button-wrapper">-->
        <!--                        &lt;!&ndash;创意赛已结束&ndash;&gt;-->
        <!--                        <template v-if="type==='创意赛'">-->
        <!--                            <div class="creative-download smallButton" @click="showDownAlert"><span>下载数据</span></div>-->
        <!--                        </template>-->
        <!--                        &lt;!&ndash;算法赛已结束&ndash;&gt;-->
        <!--                        <template v-if="type==='算法赛'">-->
        <!--                            <div class="algorithm-submit-result smallButton" @click="showSubAlert" v-if="cmptId!=331">-->
        <!--                                <span>提交结果</span></div>-->
        <!--                            <div class="algorithm-download smallButton" @click="showDownAlert"><span>下载数据</span></div>-->
        <!--                        </template>-->
        <!--                    </div>-->
        <!--                </template>-->
        <!--                &lt;!&ndash;比赛没结束&ndash;&gt;-->
        <!--                <template v-else>-->
        <!--                    <div class="button-wrapper">-->
        <!--                        <div class="invite smallButton" @click="inviteFriend" v-if="cmptId!=320&&showTag">-->
        <!--                            <span>邀请好友</span></div>-->
        <!--                        <div class="submit-result smallButton" @click="showSubAlert" v-if="cmptId!=331">-->
        <!--                            <span>提交结果</span></div>-->
        <!--                        <div class="download smallButton" @click="showDownAlert"><span>下载数据</span></div>-->
        <!--                    </div>-->
        <!--                </template>-->
        <!--            </template>-->
        <!--            &lt;!&ndash;未参赛&ndash;&gt;-->
        <!--            <template v-if="!isJoin">-->
        <!--                <div class="button-wrapper">-->
        <!--                    &lt;!&ndash;即将开始,不可报名&ndash;&gt;-->
        <!--                    <template v-if="statusState==='joinable'">-->
        <!--                        <span class="time-for-signUp">{{ time }}竞赛开始</span>-->
        <!--                        <div class="sign-up-disable smallButton"><span>{{ $t('dc_lang.报名参赛') }}</span></div>-->
        <!--                    </template>-->
        <!--                    &lt;!&ndash;已经结束&ndash;&gt;-->
        <!--                    <template v-else-if="statusState==='history'">-->

        <!--                        <div class="signUp-for-closed smallButton" v-if="formData.status == 1" @click="goForm">-->
        <!--                            <span>审核中</span></div>-->
        <!--                        <div class="signUp-for-closed smallButton" v-else-if="formData.status == 2" @click="beforeJude">-->
        <!--                            <span>审核通过</span></div>-->
        <!--                        <div class="signUp-for-closed smallButton" v-else-if="formData.status == 3"-->
        <!--                             @click="showErrorAlert"><span>审核未通过</span></div>-->
        <!--                        <div class="signUp-for-closed smallButton" v-else @click="signUpAlert">-->
        <!--                            <span>{{ $t('dc_lang.报名参赛') }}</span></div>-->
        <!--                    </template>-->
        <!--                    &lt;!&ndash;报名参赛,未报名&ndash;&gt;-->
        <!--                    <template v-else>-->
        <!--                        <div class="invite smallButton" @click="inviteFriend" v-if="cmptId!=320&&showTag">-->
        <!--                            <span>邀请好友</span></div>-->

        <!--                        <div class="signUp smallButton" v-if="!formData.status" @click="signUpAlert">-->
        <!--                            <span>{{ $t('dc_lang.报名参赛') }}</span>-->
        <!--                        </div>-->
        <!--                        <div class="signUp smallButton" v-else-if="formData.status == 1" @click="goForm">-->
        <!--                            <span>审核中</span></div>-->
        <!--                        <div class="signUp smallButton" v-else-if="formData.status == 2" @click="signUpAlert">-->
        <!--                            <span>审核通过</span></div>-->
        <!--                        <div class="signUp smallButton" v-else-if="formData.status == 3" @click="showErrorAlert"><span>审核未通过</span>-->
        <!--                        </div>-->
        <!--                    </template>-->
        <!--                </div>-->
        <!--            </template>-->
        <!--        </template>-->

        <div class="chatArea-wrapper" v-if="areaShow">
            <input class="chatArea" ref='replyInput' type="text" placeholder="HI,我想说......" v-model="value"/>
            <span class="sendBtn" @click="chatFirst">{{ $t('dc_lang.发送') }}</span>
        </div>
        <div class="mask" v-if="maskShow" @click="closeText"></div>
        <div class="scroll-top" v-if="scrollShow&&$route.path==='/cmptDetail.html'" @click="scrollTopFun">
            <img src="/static/img/common/scroll-top@2x.png">
        </div>
        <setPhone ref="judge"></setPhone>

        <dcAlert ref="eduEmailAlert"
                 :isSureAlertFun="true">
            <div>
                <p style="font-size: 32px;">请输入你的学生邮箱</p>
                <p style="font-size: 24px;color: #bbb;padding: 10px 0 15px">不知道什么是学生邮箱?请查看赛事常见问题</p>
                <input class="vsi-email" v-model='vsiEmail' placeholder='请输入学生邮箱'/>
            </div>
        </dcAlert>
    </div>
</template>

<script>
import api from '../../../api/api'
import BScroll from 'better-scroll'
import Bus from '../../../bus'
import qs from 'qs'
import setPhone from '../../common/set-phone/set-phone.vue'
import dcAlert from '../../../components/common/alert/alert'

export default {
    name: 'competition-detail',
    components: {
        setPhone,
        dcAlert
    },
    provide: function () {
        return {
            reload: this.reload
        }
    },
    data () {
        return {
            scrollShow: false,
            isRouterShow: true,
            routeData: {},
            barFixed: false, // 吸顶
            tab: 'tab',
            // 竞赛的信息数据
            cmptId: '',
            cmptName: '',
            userName: '',
            userId: '',
            teamId: '', // 队伍id
            isJoin: false, // 判断用户是否参赛  根据是否有teamId来判断
            teamName: '',
            publicScore: '',
            teamAvatar: '',
            latestSub: '',
            commitAccount: '',
            finalRank: '',
            statusNum: 1, /* 未参赛的竞赛信息 statusNum 0:已经结束 1:报名参赛 2:即将开始 */
            cmpTypeStatus: 1, /* 已参赛的参赛类型 若比赛已结束  cmpTypeStatus 0:创意赛 1：算法赛 */
            src: '',
            type: '',
            name: '',
            status: '',
            isStart: '',
            time: '', // 包括未结束竞赛的三种情况 竞赛开始时间 进行中的阶段结束时间 下一个阶段开始时间
            award: '',
            rewardType: '',
            host: '',
            countDown: '',
            cmpTeamNum: 0,
            cmpMemberNum: 0,
            cmpWorkNum: 0,
            // 倒计时
            days: 0,
            hours: 0,
            minutes: '',
            seconds: '',
            tipShow: false, // 竞赛已结束提示
            // 先聊一下提示框
            areaShow: false,
            maskShow: false,
            value: '',
            chatId: '', // 先聊一下 申请组队 对象的ID
            chatTeamId: '', // 申请组队的teamid
            vsiEmail: '', // 认证学生教育邮箱
            showTag: false,
            formData: {}, // 表单相关参数
            statusState: '',
            tabOffsetTop: 0,
            cmptAttr: '',
            dcCmptsetting: {}
        }
    },
    computed: { // Js国际化
        tabBarDataOut: function () {
            return [
                {
                    url: '/cmptDetail.html',
                    name: this.$t('dc_lang.竞赛信息')
                },
                // {
                //   url: '/competition-taskdata',
                //   name: this.$t('dc_lang.任务与数据')
                // },
                {
                    url: '/competition-ranking',
                    name: this.$t('dc_lang.排行榜')
                },
                // {
                //   url: '/competition-competitors',
                //   name: this.$t('dc_lang.参赛人员')
                // },
                {
                    url: '/competition-teams',
                    name: this.$t('dc_lang.参赛团队')
                },
                {
                    url: '/competition-detail/news-list.html',
                    name: this.$t('dc_lang.赛事动态')
                },
            ]
        },
        tabBarDataIn: function () {
            return [
                {
                    url: '/cmptDetail.html',
                    name: this.$t('dc_lang.竞赛信息')
                },
                // {
                //   url: '/competition-taskdata',
                //   name: this.$t('dc_lang.任务与数据')
                // },
                {
                    url: '/competition-ranking',
                    name: this.$t('dc_lang.排行榜')
                },
                // {
                //   url: '/competition-competitors',
                //   name: this.$t('dc_lang.参赛人员')
                // },
                {
                    url: '/competition-teams',
                    name: this.$t('dc_lang.参赛团队')
                },
                {
                    url: '/competition-detail/news-list.html',
                    name: this.$t('dc_lang.赛事动态')
                },
            ]
        },
        tabBarData304Out: function () {
            return [
                {
                    url: '/cmptDetail.html',
                    name: this.$t('dc_lang.竞赛信息')
                },
                {
                    url: '/login',
                    name: this.$t('dc_lang.任务与数据')
                },
                {
                    url: '/competition-detail/news-list.html',
                    name: this.$t('dc_lang.赛事动态')
                },
                {
                    url: '/login',
                    name: this.$t('dc_lang.排行榜')
                },
                {
                    url: '/competition-competitors',
                    name: this.$t('dc_lang.参赛人员')
                },
                {
                    url: '/login',
                    name: this.$t('dc_lang.参赛团队')
                }
            ]
        },
        tabBarData304In: function () {
            return [
                {
                    url: '/cmptDetail.html',
                    name: this.$t('dc_lang.竞赛信息')
                },
                {
                    url: 'https://challenge-os.videojj.com/?from=dc',
                    name: this.$t('dc_lang.任务与数据')
                },
                {
                    url: '/competition-detail/news-list.html',
                    name: this.$t('dc_lang.赛事动态')
                },
                {
                    url: 'https://challenge-os.videojj.com/?from=dc',
                    name: '提交结果'
                },
                {
                    url: 'https://challenge-os.videojj.com/?from=dc',
                    name: this.$t('dc_lang.排行榜')
                },
                {
                    url: '/competition-competitors',
                    name: this.$t('dc_lang.参赛人员')
                },
                {
                    url: 'https://challenge-os.videojj.com/?from=dc',
                    name: this.$t('dc_lang.参赛团队')
                },
                {
                    url: 'https://challenge-os.videojj.com/?from=dc',
                    name: '我的队伍'
                }
            ]
        },
        tabBarData320Out: function () {
            return [
                {
                    url: '/cmptDetail.html',
                    name: this.$t('dc_lang.竞赛信息')
                },
                {
                    url: '/competition-taskdata',
                    name: this.$t('dc_lang.任务与数据')
                },
                {
                    url: '/competition-detail/news-list.html',
                    name: this.$t('dc_lang.赛事动态')
                },
                {
                    url: '/competition-competitors',
                    name: this.$t('dc_lang.参赛人员')
                },
                {
                    url: '/competition-teams',
                    name: this.$t('dc_lang.参赛团队')
                }
            ]
        },
        tabBarData320In: function () {
            return [
                {
                    url: '/cmptDetail.html',
                    name: this.$t('dc_lang.竞赛信息')
                },
                {
                    url: '/competition-taskdata',
                    name: this.$t('dc_lang.任务与数据')
                },
                {
                    url: '/competition-detail/news-list.html',
                    name: this.$t('dc_lang.赛事动态')
                },
                {
                    url: '/competition-submission',
                    name: '提交结果'
                },
                {
                    url: '/competition-competitors',
                    name: this.$t('dc_lang.参赛人员')
                },
                {
                    url: '/competition-teams',
                    name: this.$t('dc_lang.参赛团队')
                },
                {
                    url: '/competition-myteam',
                    name: '我的队伍'
                }
            ]
        },
        tabBarData333Out: function () {
            return [
                {
                    url: '/cmptDetail.html',
                    name: this.$t('dc_lang.竞赛信息')
                },
                {
                    url: '/competition-taskdata',
                    name: this.$t('dc_lang.任务与数据')
                },
                {
                    url: '/competition-detail/news-list.html',
                    name: this.$t('dc_lang.赛事动态')
                },
                {
                    url: '/competition-competitors',
                    name: this.$t('dc_lang.参赛人员')
                },
                {
                    url: '/competition-teams',
                    name: this.$t('dc_lang.参赛团队')
                }
            ]
        },
        tabBarData333In: function () {
            return [
                {
                    url: '/cmptDetail.html',
                    name: this.$t('dc_lang.竞赛信息')
                },
                {
                    url: '/competition-taskdata',
                    name: this.$t('dc_lang.任务与数据')
                },
                {
                    url: '/competition-detail/news-list.html',
                    name: this.$t('dc_lang.赛事动态')
                },
                {
                    url: '/competition-submission',
                    name: '提交结果'
                },
                {
                    url: '/competition-competitors',
                    name: this.$t('dc_lang.参赛人员')
                },
                {
                    url: '/competition-teams',
                    name: this.$t('dc_lang.参赛团队')
                },
                {
                    url: '/competition-myteam',
                    name: '我的队伍'
                }
            ]
        },
        tabBarData331Out: function () {
            return [
                {
                    url: '/cmptDetail.html',
                    name: this.$t('dc_lang.竞赛信息')
                },
                {
                    url: '/competition-taskdata',
                    name: this.$t('dc_lang.任务与数据')
                },
                {
                    url: '/competition-detail/news-list.html',
                    name: this.$t('dc_lang.赛事动态')
                },
                {
                    url: '/competition-ranking',
                    name: this.$t('dc_lang.排行榜')
                },
                {
                    url: '/competition-competitors',
                    name: this.$t('dc_lang.参赛人员')
                },
                {
                    url: '/competition-teams',
                    name: this.$t('dc_lang.参赛团队')
                }
            ]
        },
        tabBarData331In: function () {
            return [
                {
                    url: '/cmptDetail.html',
                    name: this.$t('dc_lang.竞赛信息')
                },
                {
                    url: '/competition-taskdata',
                    name: this.$t('dc_lang.任务与数据')
                },
                {
                    url: '/competition-detail/news-list.html',
                    name: this.$t('dc_lang.赛事动态')
                },
                {
                    url: '/competition-ranking',
                    name: this.$t('dc_lang.排行榜')
                },
                {
                    url: '/competition-competitors',
                    name: this.$t('dc_lang.参赛人员')
                },
                {
                    url: '/competition-teams',
                    name: this.$t('dc_lang.参赛团队')
                },
                {
                    url: '/competition-myteam',
                    name: '我的队伍'
                }
            ]
        },
        tabBarData377Out: function () {
            return [
                {
                    url: '/cmptDetail.html',
                    name: this.$t('dc_lang.竞赛信息')
                },
                {
                    url: '/competition-taskdata',
                    name: '赛事平台'
                },
                {
                    url: '/competition-detail/news-list.html',
                    name: this.$t('dc_lang.赛事动态')
                },
                {
                    url: '/competition-ranking',
                    name: this.$t('dc_lang.排行榜')
                },
                {
                    url: '/competition-competitors',
                    name: this.$t('dc_lang.参赛人员')
                },
                {
                    url: '/competition-teams',
                    name: this.$t('dc_lang.参赛团队')
                }
            ]
        },
        tabBarData377In: function () {
            return [
                {
                    url: '/cmptDetail.html',
                    name: this.$t('dc_lang.竞赛信息')
                },
                {
                    url: '/competition-taskdata',
                    name: '赛事平台'
                },
                {
                    url: '/competition-detail/news-list.html',
                    name: this.$t('dc_lang.赛事动态')
                },
                {
                    url: '/competition-submission',
                    name: '提交结果'
                },
                {
                    url: '/competition-ranking',
                    name: this.$t('dc_lang.排行榜')
                },
                {
                    url: '/competition-competitors',
                    name: this.$t('dc_lang.参赛人员')
                },
                {
                    url: '/competition-teams',
                    name: this.$t('dc_lang.参赛团队')
                },
                {
                    url: '/competition-myteam',
                    name: '我的队伍'
                }
            ]
        },
        sureTxt: function () {
            return this.$t('dc_lang.好的')
        },
        alertTitle: function () {
            return this.$t('dc_lang.温馨提示')
        },
        alertMessage: function () {
            return this.$t('dc_lang.暂不支持下载数据，请至DC竞赛PC端下载。')
        }
    },
    beforeCreate: function () {
        // this.$i18n.locale = "en-US";
    },
    methods: {
        sureEduAlert: function () {
            const me = this
            const emailReg = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/
            // eslint-disable-next-line eqeqeq
            if (me.vsiEmail != '' && emailReg.test(me.vsiEmail)) {
                api.setUserVsiEmailUrl({
                    vsiEmail: me.vsiEmail
                }).then((response) => {
                    me.common.axiosSuccessFun({
                        this: me,
                        callBack (res) {
                            me.vsiEmail = ''
                            me.$refs.eduEmailAlert.closeAlert()
                            me.$parent.$refs.alertCompo.setProps({
                                singleBtn: true,
                                alertMessage: '请使用你填写的学生邮箱向' + res.data.vsiEmail + '发送任意一封邮件。'
                            })
                        }
                    }, response.data)
                }).catch((error) => {
                    me.common.axiosFailFun({
                        this: me
                    }, error)
                })
            } else {
                me.$parent.$refs.toastCompo.showFun({
                    msg: '邮箱格式错误!',
                    time: 800
                })
            }
        },
        reload: function () {
            this.isRouterShow = false
            this.$nextTick(function () {
                this.isRouterShow = true
            })
        },
        initScroll: function () {
            this.$nextTick(() => {
                if (!this.scroll) {
                    this.scroll = new BScroll(this.$refs.scrollView, {
                        click: true,
                        scrollX: true
                    })
                } else {
                    this.scroll.refresh()
                }
            })
        },
        countTimeFun: function (time) {
            let me = this
            let days, hours, minutes, seconds
            // 判断是否开启定时器
            let now = new Date().getTime()
            // 倒计时
            if ((time - now) > 0) { // 判断是否开启定时器
                let interval = setInterval(function () {
                    // 获取当前时间
                    let now = new Date().getTime()
                    // 获取倒计时秒数
                    let countDown = time - now
                    if (countDown > 0) {
                        // 获取天数
                        days = Math.floor(countDown / 1000 / 60 / 60 / 24)
                        hours = Math.floor(countDown / 1000 / 60 / 60 % 24)
                        minutes = Math.floor(countDown / 1000 / 60 % 60)
                        seconds = Math.floor(countDown / 1000 % 60)
                        if (hours < 10) {
                            hours = '0' + hours
                        }
                        if (minutes < 10) {
                            minutes = '0' + minutes
                        }
                        if (seconds < 10) {
                            seconds = '0' + seconds
                        }
                        me.days = days
                        me.hours = hours
                        me.minutes = minutes
                        me.seconds = seconds
                    } else {
                        clearInterval(interval)
                    }
                }, 1000)
            }
        },
        getCmptMessage: function () {
            let me = this
            let cmptId = me.cmptId
            const messageName = '竞赛信息'
            let type = '' // 竞赛类型
            const algorithmCmpt = '算法赛'
            const creativeCmpt = '创意赛'
            api.competitionDetailsUrl({
                id: cmptId,
                detail: messageName
            }).then((response) => {
                let res = response.data
                me.common.axiosSuccessFun({
                    callBack: function (response) {
                        let res = response.data
                        let rcd = res.cmptDetail.dcCompetition
                        me.dcCmptsetting = rcd
                        me.$parent.titleName = rcd.name
                        let _arr = res.userFormAuditOpinion ? res.userFormAuditOpinion.split('|') : []
                        me.formData = {
                            hasData: res.userFormExist,
                            status: res.userFormAuditStatus,
                            reason: _arr[0],
                            desc: _arr[1],
                            isWriteFormInfo: rcd.isWriteFormInfo,
                            isAudit: rcd.isAudit,
                        }
                        me.countTimeFun(res.cmptDetail.dcCmptsetting.signupEndTime)
                        // 判断竞赛类型
                        if (rcd.type === '结果提交型') {
                            type = algorithmCmpt
                        } else if (rcd.type === '创意型') {
                            type = creativeCmpt
                        }

                        // 判断竞赛的阶段
                        let cts = res.currentStage
                        let currentStatus = cts ? cts.currentStageName : ''
                        me.statusState = res.state
                        let isStart = false
                        if (me.statusState !== 'history') { // 判断阶段是否正在进行
                            let cts = res.currentStage || {}
                            isStart = cts ? cts.start : ''
                            let ctss = cts.currentStage ? cts.currentStage : undefined
                            if (me.statusState === 'joinable') {
                                // 竞赛开始时间
                                let time = ctss ? ctss.start : ''
                                me.time = me.common.format(time, 'yyyy-MM-dd HH:mm')
                            } else {
                                // if (isStart) { // 阶段进行中
                                //     // 倒计时时间
                                //     let stateEndTime = ctss ? ctss.end : ''
                                //     me.time = stateEndTime
                                //     // 开启定时器
                                //
                                // } else { // 阶段
                                //     // 下个阶段开始时间
                                //     me.wrap = true // 换行
                                //     me.time = me.common.format(ctss ? ctss.start : '', 'yyyy-MM-dd HH:mm')
                                // }
                            }
                        }

                        // 处理奖金的金钱符号
                        let rcd_reward = rcd.reward
                        me.rewardType = rcd.rewardType
                        if (me.rewardType == '奖金' && !(Number.isNaN(Number(rcd_reward.charAt(0))))) {
                            rcd_reward = '￥' + rcd_reward
                        }

                        me.cmptId = rcd.id
                        me.cmptAttr = res.cmptAttr
                        me.cmptName = rcd.name
                        me.common.addCookieSync('cmptId', me.cmptId)
                        me.showTag = true
                        me.src = rcd.icon
                        me.type = type
                        me.name = rcd.name
                        me.$parent.titleName = me.name
                        me.award = rcd_reward
                        me.host = res.hostDetail.name
                        me.cmpTeamNum = res.cmptUserAndTeamAndUpload.team
                        me.cmpMemberNum = res.cmptUserAndTeamAndUpload.user
                        me.cmpWorkNum = res.cmptUserAndTeamAndUpload.upload
                        me.status = currentStatus
                        me.isStart = isStart
                        me.isVerified = res.isVerified ? res.isVerified : ''
                        me.isJoin = res.joinTeam
                        if (me.isJoin) { // 这里是已参赛的队伍数据
                            me.teamId = res.teamId
                            me.teamName = res.teamName
                            // me.isJoin = res.joinTeam;
                            // me.publicScore = res.team.publicScore
                            // 人员参与的团队提交结果信息
                            // let latestSub = me.common.format(res.latestCommit, 'yyyy-MM-dd')
                            // res.myTeamAllSuccessUploads = res.myTeamAllSuccessUploads ? res.myTeamAllSuccessUploads : 0
                            // me.teamAvatar = res.team.avatar
                            // me.latestSub = latestSub
                            // me.commitAccount = res.myTeamAllSuccessUploads
                            // me.finalRank = res.team.finalRank
                        } else { // 在退出队伍以后刷新页面 更新状态
                            me.teamId = ''
                            me.teamName = ''
                            me.isJoin = false
                            me.publicScore = ''
                        }
                    },
                    this: me
                }, res)
            }).catch((error) => {
                console.log(error)
                me.common.axiosFailFun({this: me}, error)
            })
        },
        // 判断此用户是否需要强制收集信息
        judgeUserPhoneFun: function (type, callBack) {
            const me = this
            api.judgeUserPhoneUrl({
                cmptId: me.cmptId,
                type: type
            }).then((respon) => {
                me.common.axiosSuccessFun({
                    this: me,
                    fail: false,
                    failBack (resp) {
                        if (resp.msg == '请填写手机号') {
                            me.$refs.judge.alertHidden = false
                        } else {
                            me.$parent.$refs.alertCompo.setProps({
                                singleBtn: true,
                                alertMessage: resp.msg
                            })
                        }
                    },
                    callBack () {
                        if (callBack) {
                            callBack()
                        }
                    }
                }, respon.data)
            }).catch((resp) => {
                me.common.axiosFailFun({
                    this: me
                }, resp)
            })
        },
        // 304弹框
        signUpAlert304: function () {
            const me = this
            me.$parent.$refs.alertCompo.setProps({
                alertTitle: me.alertTitle,
                singleBtn: true,
                sureTxt: '报名参赛',
                alertMessage: '视频小程序开发者大赛2019夏季赛',
                sureFun: function () {
                    me.signUpAlert()
                }
            })
        },
        // 报名参赛弹窗
        signUpAlert: function () {
            let me = this
            return me.$parent.$refs.alertCompo.setProps({
                alertTitle: me.alertTitle,
                alertMessage: '请到官网(www.datacastle.cn）进行报名、组队及作品提交。'
            })
            if (me.cmptId == 320) {

            } else {
                me.common.checkLogin({
                    callBack: function () {
                        let canDo = !me.formData.isAudit && me.formData.hasData // 不需要审核的报名表单已经填写完毕
                        if (me.formData.isWriteFormInfo && canDo) {
                            me.agree()
                            return
                        }
                        me.judgeUserPhoneFun('create', function () {
                            me.$parent.$refs.alertCompo.setProps({
                                alertTitle: me.alertTitle,
                                alertMessage: '请先阅读比赛规则，确认同意后方可参赛',
                                sureFun: function () {
                                    me.beforeJude()
                                },
                                rule: '我已阅读，并同意全部竞赛规则'
                            })
                        })
                    },
                    url: me.$route.path + '?id=' + me.cmptId,
                    this: me
                })
            }
        },

        beforeJude: function () {
            let me = this
            api.beforeCreateTeam({
                cmptId: me.cmptId
            }).then((respon) => {
                me.common.axiosSuccessFun({
                    this: me,
                    fail: false,
                    callBack (resp) {
                        me.judgeGoForm()
                    },
                    failBack (resp) {
                        let data = resp.data
                        if (data.isCollectUserInfo) {
                            me.$parent.$refs.alertCompo.setProps({
                                alertTitle: me.alertTitle,
                                alertMessage: '为了更好的服务于参赛者，参赛者报名参赛填写或提交的参赛者个人信息（包括姓名、手机号、单位/学校、电子邮箱、参赛队名）将共享给本次' + me.cmptName + '的举办方' + resp.data.hostName + '，以便大赛举办方与参赛者联系或优化参赛者的参赛体验。举办方承诺仅以前述目的使用您的信息。',
                                rule: '我已阅读并同意上述内容',
                                select: false,
                                isSureAlertFun: false,
                                sureFun: function () {
                                    if (this.select) {
                                        this.show = false
                                        api.passCollectUserInfo({
                                            cmptId: me.cmptId
                                        }).then((response) => {
                                            let res = response.data
                                            me.common.axiosSuccessFun({
                                                this: me,
                                                callBack: function (response) {
                                                    me.beforeJude()
                                                }
                                            }, res)
                                        }).catch((error) => {
                                            me.common.axiosFailFun({
                                                this: me
                                            })
                                        })
                                    }
                                },
                                cancelFun: function () {

                                }
                            })
                        } else if (data.isVerifiedFlag) { // 需要实名认证-前往个人中心
                            let str = []
                            for (let i in data.verifiedInfo) {
                                str.push(i)
                            }
                            me.$parent.$refs.alertCompo.setProps({
                                alertTitle: me.alertTitle,
                                alertMessage: '请完善以下认证信息：' + str.join('、'),
                                sureTxt: '去完善',
                                sureFun: function () {
                                    me.$router.push('/myInfo')
                                }
                            })
                        } else if (data.verifyStatus === 'complete') {
                            me.$parent.$refs.alertCompo.setProps({
                                alertTitle: me.alertTitle,
                                alertMessage: '本次竞赛需要参赛者提交报名信息，请您到PC端报名参赛，谢谢您的支持！',
                                singleBtn: true,
                                sureTxt: '确定'
                            })
                        } else if (data.verifyStatus === 'submit') {
                            me.$parent.$refs.alertCompo.setProps({
                                alertTitle: me.alertTitle,
                                alertMessage: resp.msg,
                                cancelTxt: '取消',
                                sureTxt: '确定',
                                sureFun: function () {
                                    api.submitVerifyUser()
                                }
                            })
                        } else if (data.verifyStatus === 'submit') {
                            me.$parent.$refs.alertCompo.setProps({
                                alertTitle: me.alertTitle,
                                alertMessage: resp.msg,
                                cancelTxt: '取消',
                                sureTxt: '确定',
                                sureFun: function () {
                                    api.submitVerifyUser()
                                }
                            })
                        } else {
                            me.$parent.$refs.alertCompo.setProps({
                                alertTitle: me.alertTitle,
                                alertMessage: resp.msg,
                                singleBtn: true,
                                sureTxt: '确定'
                            })
                        }
                    }
                }, respon.data)
            }).catch((resp) => {
                me.common.axiosFailFun({
                    this: me
                }, resp)
            })
        },
        // 报名参赛弹窗确认后的弹窗
        agree: function () {
            let me = this
            me.$parent.$refs.alertCompo.setProps({
                alertTitle: me.alertTitle,
                alertMessage: '我们希望您以团队形式参赛，请选择组建团队的方式：',
                cancelTxt: '加入已有团队',
                sureTxt: '自己创建',
                sureFun: function () {
                    me.createTeam()
                },
                cancelFun: function () {
                    me.$router.push({path: '/team-page', query: {id: me.cmptId}})
                }
            })
        },
        // 自己创建
        createTeam: function () {
            let me = this
            api.createTeamUrl({
                cmpId: me.cmptId
            }).then((response) => {
                let res = response.data
                me.common.axiosSuccessFun({
                    callBack: function (response) {
                        if (response.msg.indexOf('前往科大讯飞') > -1) {
                            window.location.href = response.data.xunfeiUrl
                        } else {
                            // 更新报名参赛后的队伍信息
                            me.getCmptMessage()
                            me.isJoin = true
                            me.$router.push({
                                path: '/competition-myteam',
                                query: {id: me.cmptId}
                            })
                        }
                    },
                    failBack: function (response) {
                        let msg = response.msg
                        if (msg.indexOf('完善信息') != '-1') { // 跳去实名认证
                            me.$parent.$refs.alertCompo.setProps({
                                alertTitle: me.alertTitle,
                                alertMessage: msg,
                                singleBtn: true,
                                sureTxt: '去认证',
                                sureFun: function () {
                                    me.$router.push({path: '/certification'})
                                }
                            })
                        } else if (msg.indexOf('你不满足参赛') != '-1') {
                            me.$parent.$refs.alertCompo.setProps({
                                alertTitle: me.alertTitle,
                                alertMessage: '你不满足参赛要求，请查看"竞赛信息——参赛与组队规则"',
                                singleBtn: true,
                                sureTxt: me.sureTxt
                            })
                        } else if (msg.indexOf('请认证学生身份') != '-1') {
                            me.$parent.$refs.alertCompo.closeAlert()
                            me.$refs.eduEmailAlert.setProps({
                                show: true,
                                isSureAlertFun: false,
                                alertTitle: '主办方要求进行学生认证',
                                cancelFun: () => {
                                    me.vsiEmail = ''
                                },
                                sureFun: () => {
                                    me.sureEduAlert()
                                }
                            })
                        } else if (msg.indexOf('本次大赛仅限全国在校大学生参赛报名') != '-1') {
                            me.$parent.$refs.alertCompo.closeAlert()
                            me.$parent.$refs.alertCompo.setProps({
                                alertTitle: me.alertTitle,
                                alertMessage: msg,
                                singleBtn: false,
                                sureTxt: '去完善',
                                sureFun: () => {
                                    me.$router.push('/xinwang-myInfo/' + me.$route.query.name)
                                }
                            })
                        }
                    },
                    url: me.$route.path + '?id=' + me.cmptId,
                    this: me
                }, res)
            }).catch((error) => {
                me.common.axiosFailFun({
                    this: me
                })
            })
        },
        // 判断是否跳转到报名表单页面
        judgeGoForm () {
            const me = this
            let canDo = !me.formData.isAudit && me.formData.hasData // 不需要审核的报名表单
            if (me.formData.isWriteFormInfo && me.formData.status !== '2' && !canDo) {
                me.goForm()
                return
            }
            me.agree()
        },
        // 跳转到报名表单页面
        goForm () {
            this.$router.push('/joinForm.html?id=' + this.cmptId)
        },
        // 展示未通过原因
        showErrorAlert () {
            const me = this
            this.formData.reason = '图片不清晰'
            let desc = this.formData.desc ? this.formData.desc : ''
            this.$parent.$refs.alertCompo.setProps({
                sureTxt: '去修改',
                alertTitle: '审核不通过原因',
                alertMessage: this.formData.reason + '<br/>' + desc,
                sureFun: function () {
                    me.goForm()
                }
            })
        },
        // 邀请好友
        inviteFriend: function () {
            let me = this
            let params = {
                cmptId: Number(me.cmptId)
            }
            if (me.isJoin) {
                params.teamId = me.teamId
            }
            me.common.checkLogin({
                callBack: function () {
                    me.$api.beforeInviteMemApi(params).then(res => {
                        me.common.axiosSuccessFun({
                            callBack: function (response) {
                                me.$router.push({path: '/invite-friend', query: {cmptId: me.cmptId, teamId: me.teamId}})
                            },
                            this: me,
                            url: me.$route.path + '?id=' + me.cmptId
                        }, res.data)
                    })
                },
                this: me,
                url: me.$route.path + '?id=' + me.cmptId
            })
        },
        tip: function () { // 竞赛已结束提示框
            this.tipShow = !this.tipShow
        },
        // 点击发送聊天内容
        chatFirst: function () {
            let me = this
            if (me.value.length < 1) {
                me.$parent.$refs.alertCompo.setProps({
                    sureTxt: me.sureTxt,
                    alertTitle: me.alertTitle,
                    alertMessage: '内容不能为空',
                    singleBtn: true
                })
            } else if (me.value.length > 25) { // 内容不能超过25个字
                me.$parent.$refs.alertCompo.setProps({
                    sureTxt: me.sureTxt,
                    alertTitle: me.alertTitle,
                    alertMessage: '内容不能超过25个字',
                    singleBtn: true
                })
            } else {
                me.sendMessage()
            }
        },
        // 先聊一下 发送聊天内容
        sendMessage: function () {
            let me = this
            this.areaShow = false
            this.maskShow = false
            // 判断用户是否登录,已经登录则请求数据,未登录则前往登录页面
            me.common.checkLogin({
                url: '/mine',
                this: me,
                callBack: () => {
                    api.beforeSendMessageApi({
                        cmptId: Number(me.cmptId),
                        receiverId: me.chatId,
                        teamId: me.chatTeamId,
                        type: '私信'
                    }).then((res) => {
                        me.common.axiosSuccessFun({
                            fail: false,
                            failBack (resp) {
                                if (resp.data.verifyStatus === 'complete') {
                                    me.$parent.$refs.alertCompo.setProps({
                                        alertTitle: me.alertTitle,
                                        alertMessage: '本次竞赛需要参赛者提交报名信息，请您到PC端报名参赛，谢谢您的支持！',
                                        singleBtn: true,
                                        sureTxt: '确定'
                                    })
                                } else if (resp.data.verifyStatus === 'submit') {
                                    me.$parent.$refs.alertCompo.setProps({
                                        alertTitle: me.alertTitle,
                                        alertMessage: resp.msg,
                                        cancelTxt: '取消',
                                        sureTxt: '确定',
                                        sureFun: function () {
                                            api.submitVerifyUser()
                                        }
                                    })
                                } else {
                                    me.$parent.$refs.alertCompo.setProps({
                                        alertTitle: me.alertTitle,
                                        alertMessage: resp.msg,
                                        singleBtn: true,
                                        sureTxt: '确定'
                                    })
                                }
                            },
                            callBack (response) {
                                api.chatApplyUrl({
                                    cmptId: Number(me.cmptId),
                                    senderName: me.userName,
                                    receiverId: me.chatId,
                                    type: '私信',
                                    content: me.value
                                }).then((response) => {
                                    let res = response.data
                                    if (res.flag) {
                                        me.$parent.$refs.alertCompo.setProps({
                                            sureTxt: me.sureTxt,
                                            alertTitle: me.alertTitle,
                                            alertMessage: '消息发送成功',
                                            singleBtn: true
                                        })
                                    } else {
                                        me.$parent.$refs.alertCompo.setProps({
                                            sureTxt: me.sureTxt,
                                            alertTitle: me.alertTitle,
                                            alertMessage: res.msg,
                                            singleBtn: true
                                        })
                                    }
                                }).catch((error) => {
                                })
                            },
                            this: me,
                            url: me.$route.path + '?id=' + me.cmptId
                        }, res.data)
                    })
                }
            })
        },
        // 提交结果弹窗
        showSubAlert: function () {
            const me = this
            me.judgeUserPhoneFun('commit', function () {
                me.$parent.$refs.alertCompo.setProps({
                    sureTxt: me.sureTxt,
                    alertTitle: me.alertTitle,
                    alertMessage: '暂不支持提交比赛结果，请至DC竞赛PC端提交。',
                    singleBtn: true
                })
            })
        },
        // 下载数据弹窗
        showDownAlert: function () {
            this.$parent.$refs.alertCompo.setProps({
                sureTxt: this.sureTxt,
                alertTitle: this.alertTitle,
                alertMessage: this.alertMessage,
                singleBtn: true
            })
        },
        // 点击蒙版关闭打字框
        closeText: function () {
            this.areaShow = false
            this.maskShow = false
            this.value = ''
        },
        scrollTopFun: function () {
            window.scrollTo(0, 0)
            setTimeout(() => {
                this.scrollShow = false
            }, 50)
        },
        handleScroll: function () { // 滑动页面监听
            let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
            let offsetTop = this.tabOffsetTop ? this.tabOffsetTop : this.$refs.scrollViewBox.offsetTop
            if (scrollTop >= offsetTop && !this.barFixed) {
                this.barFixed = true
            } else if (scrollTop < offsetTop && this.barFixed) {
                this.barFixed = false
            }
            this.scrollShow = scrollTop > 50
            if (this.tabOffsetTop < 1 && offsetTop > 0) {
                this.tabOffsetTop = offsetTop
            }
        }
    },
    watch: {
        isJoin: function () {
            this.$nextTick(() => {
                this.initScroll()
            })
        },
        '$i18n.locale' () {
        }
    },
    created: function () {
        const that = this
        that.$parent.$refs.toastCompo.showLoading({
            msg: '加载中...'
        })
        if (that.common.getCookieSync('loginUser')) {
            that.userName = JSON.parse(that.common.getCookieSync('loginUser')).userName || ''
            that.userId = JSON.parse(that.common.getCookieSync('loginUser')).id || ''
        }
    },
    mounted: function () {
        let me = this
        if (me.$route.query.from == 'xinwangzaidu') {
            me.signUpAlert()
        }
        let id = me.$route.query.id
        if (id) {
            me.cmptId = id
            me.getCmptMessage()
            me.$nextTick(() => {
                me.initScroll()
            })
        } else {
            let name = me.$route.query.name
            if (name) {
                api.getCpmtIdNoLogin({
                    name: name
                }).then(response => {
                    let res = response.data
                    if (res.flag && res.data.dcCompetition) {
                        me.cmptId = res.data.dcCompetition.id
                        me.getCmptMessage()
                        me.$nextTick(() => {
                            me.initScroll()
                            me.$router.replace(`/cmptDetail.html?id=${me.cmptId}`)
                        })
                    } else {
                        me.$router.replace(`/index`)
                    }
                })
            } else {
                me.$router.push(`/index`)
            }
        }

        window.addEventListener('scroll', this.handleScroll)
    },
    destroyed: function () {
        window.removeEventListener('scroll', this.handleScroll)
        this.$parent.$refs.alertCompo.closeAlert()
    }
}

</script>

<style scoped lang="scss">
.vsi-email {
    box-sizing: border-box;
    outline: none;
    width: 500px; /*px*/
    border: 1px solid #aaa;
    font-size: 32px; /*px*/
    padding: 10px 20px; /*px*/
    color: #17181A;
}

.blank-container {
    overflow: hidden;
}

.banner {
    font-size: 0;
}

.banner img {
    width: 100%;
}

.cmpt-detail {
    padding: 0 30px 30px 30px;
    background-color: #ffffff;
}

.cmpt-type {
    /*min-width: 160px;*/
    padding: 0 29px;
    box-sizing: border-box;
    height: 60px;
    display: table;
    line-height: 60px;
    background-color: #FF8766;
    border-radius: 2px;
    box-shadow: 0 8px 16px 0 rgba(64, 226, 186, 0.25);
    font-size: 34px;
    color: #fff;
    text-align: center;
    position: relative;
    bottom: 90px;
    left: 180px;
}

.cmpt-type-yq {
    /*min-width: 160px;*/
    @extend .cmpt-type;
    bottom: 30px;
    left: 0 !important;
    background: #4CA6FF;
}

.cmpt-title {
    font-size: 36px; /*px*/
    color: #17181A;
    margin-bottom: 20px;
}

.total-award {
    font-size: 28px; /*px*/
}

.cmpt-money {
    color: #FF6B55;
    line-height: 40px;
    font-size: 48px; /*px*/
}

.cmpt-award {
    margin-bottom: 20px;
}

.cmpt-host {
    font-size: 28px; /*px*/
    margin-bottom: 20px;
    margin-top: 10px;
}

.cmpt-progress {
    display: flex;
    font-size: 28px;
    margin-bottom: 30px;
    margin-top: 10px;
}

.progress-left {
    margin-right: 40px;
    display: flex;
    align-items: center;
}

.status {
    color: #BDC1C7;
    margin-right: 10px;
}

.progress-right {
    display: flex;
    align-items: center;
    /*margin-top: 20px*/
}

.cmpt-progress img {
    width: 28px;
    height: 28px;
    margin-right: 4px;
}

.cmpt-progress span {
    flex: 1;
}

.cmpt-data {
    display: flex;
    justify-content: space-between;
    font-size: 28px;
    color: #BDC1C7;
}

.scroll-view {
    /*height:96px;*/
    padding: 10px 0 10px 30px;
    box-sizing: border-box;
    background-color: #ffffff;
    margin-top: 20px;
}

.scroll-view-inner {
    width: 100%;
    /*overflow: hidden;*/
}

.tab-wrapper {
    white-space: nowrap;
    min-width: 100px;
    display: table;
    content: '';
}

.tab {
    height: 56px;
    color: #BDC1C7;
    font-size: 28px; /*px*/
    margin-right: 55px;
    display: inline-flex;
    align-items: center;
    border-radius: 4px;
    padding: 8px 14px;
    box-sizing: border-box;
}

.selected {
    background-color: #4DA6FF;
    color: #ffffff;
}

.barFixed {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    margin-top: 0;
    z-index: 99;
}

/*按钮*/
.button-wrapper {
    padding: 0 30px;
    display: flex;
    justify-content: flex-end;
    background-color: #ffffff;
    box-shadow: 0 -20px 40px 0 rgba(63, 98, 122, 0.08);
    position: fixed;
    bottom: -1px;
    width: 100%;
    box-sizing: border-box;
}

.button-wrapper .smallButton {
    margin: 14px 0 14px 20px;
}

.invite, .submit-result, .algorithm-submit-result {
    border: 4px solid #4DA6FF;
    color: #4DA6FF;
    background-color: #ffffff;
}

.signUp, .download, .algorithm-download, .creative-download {
    color: #ffffff;
    background-color: #4DA6FF;
}

.time-for-signUp {
    height: 60px;
    line-height: 60px;
    background-color: #4DA6FF;
    font-size: 24px; /*px*/
    color: #ffffff;
    text-align: center;
    position: fixed;
    bottom: 98px;
    right: 0;
    left: 0;
}

.sign-up-disable {
    background-color: #F2F4F5;
    color: #BDC1C7;
    border: none
}

.signUp-for-closed {
    color: #ffffff;
    background-color: #4DA6FF;
}

/*先聊提下框*/
.chatArea-wrapper {
    height: 98px;
    width: 100%;
    box-shadow: 0 -20px 40px 0 rgba(63, 98, 122, 0.08);
    border-radius: 20px 20px 0 0;
    font-size: 28px; /*px*/
    position: fixed;
    bottom: 0;
    background-color: #ffffff;
    z-index: 9999;
}

.chatArea {
    width: 80%;
    height: 68px;
    padding-left: 36px;
    color: #797C80;
    background-color: #ffffff;
    padding-top: 10px;
    font-size: 28px; /*px*/
}

.sendBtn {
    position: absolute;
    right: 30px;
    top: 30px;
    color: #4DA6FF;
}

.mask {
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    opacity: 0.5;
    background: #000000;
    z-index: 999;
}

/*竞赛完成提示*/
.finish-toast {
    background: url("//pu-datacastle.oss-cn-qingdao.aliyuncs.com/master.third.source/cmptmini/img/finish_toast@2x.png") no-repeat;
    background-size: 100% 100%;
    position: absolute;
    width: 371px;
    height: 90px;
    border-radius: 12px;
    padding: 20px 27px 8px 26px;
    display: flex;
    align-items: center;
    font-size: 24px;
    color: #FFFFFF;
    right: -316px;
    top: 40px;
    box-sizing: border-box;
}

</style>



// WEBPACK FOOTER //
// src/components/competition/competition-detail/competition-detail.vue